import { fetchActiveMeetingTransactions } from "."
import { db, deleteCacheByKey, updateDependencyRecords } from "../../../view/shared/utilities/cache"
import { backendAPI } from "../../api"
import { safeApiCall } from "../../api/offline"
import { processOfflineQueue } from "../../api/queue"
import { triggerAction } from "../../constants"
import { MEETING_LOADED_FROM_DB } from "../../reducers/base/meeting"
import { fetchMeetingTransactions, meetingTransactionsLoaded } from "../getTransactions"

export const meetingLoadStarted = (bool) => ({
  type: "MEETING_LOAD_START",
  isloading: bool,
})

export const meetingLoaded = (meeting) => ({
  type: "MEETING_ITEM",
  meeting,
})

export const meetingLoadError = (bool) => ({
  type: "MEETING_LOAD_ERROR",
  error: bool,
})

export function fetchMeeting() {
  return async function (dispatch, getState) {
    dispatch(meetingLoadStarted(true))
    try {
      const { group, user, isConnected } = getState()
      if (!group?.id) {
        console.error("Group ID is missing.")
        dispatch(meetingLoadError(new Error("Group ID is missing.")))
        dispatch(meetingLoadStarted(false))
        return
      }
      const url = `/groups-hedera/${group?.id}/meetings`
      const res = await safeApiCall(
        {
          cacheEnabled: true,
          url: url,
        },
        async () => backendAPI.get(url),
      )
      let ongoingMeeting = null;
      const closedMeetings = [];
      const metaObject = { userId: user?.id }
      let resolvedDependency = false
      const requests = await db.offlineRequests.toArray();

      for (const meeting of res.data) {
        // see it is a dependency to other requests
        const requiresMeetingId = requests.filter(({ needBodyUpdate, userId }) => {
          return userId === metaObject.userId && needBodyUpdate?.meeting_id === meeting.request_id
        })
        if (requiresMeetingId.length > 0) {
          await updateDependencyRecords(
            [meeting?.request_id, metaObject.userId],
            {
              ...metaObject,
              key: "meeting_id",
              value: meeting.id,
              entityType: meeting?.request_id,
            },
            metaObject.userId
          )
          resolvedDependency = true
        }
        else {
          // clean up, if not required
          await db.table('depsMap')
            .where({
              entityType: meeting.request_id,
              userId: metaObject.userId
            })
            .delete();
        }

        if (meeting.status !== "ongoing") {
          closedMeetings.push(meeting);
        }
        else {
          ongoingMeeting = meeting;
          dispatch(triggerAction(MEETING_LOADED_FROM_DB, meeting))
          if (isConnected) {
            dispatch(fetchActiveMeetingTransactions(meeting.id))
          }
          // dispatch(triggerAction("SET_ACTIVE_MEETING_TRANSACTIONS",
          //   meeting?.transactions.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).map(item => ({
          //     ...item,
          //     meetingId: meeting.id
          //   }))
          // ))
          await deleteCacheByKey("offlineRequests", "cacheId", meeting.request_id)
        }
      }
      dispatch(meetingLoadStarted(false))
      dispatch(triggerAction("SET_PREVIOUS_MEETING_DATA", closedMeetings))

      if (resolvedDependency) {
        // A dependency been resolved. start processing
        processOfflineQueue()
      }

      return Promise.resolve();
    } catch (error) {
      dispatch(meetingLoadError(error))
      return Promise.reject()
    }
  }
}
